

define(['angular', 'squid/index', 'components/xo-beaver/dist/logger', './resolvers', './language', './helper'], function (angular, squid) {

    return angular.module('xolocale', ['squid', 'beaver', 'locale.resolvers', 'locale.resolvers.language', 'locale.helper']);
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-locale/dist/index.js
// module id = ./components/xo-locale/dist/index.js
// module chunks = 1